import { Button, Card, CardContent, useToast } from "alm-react-components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APPROUTES, StatusCode } from "../../../assets/constants/constants";
import { registrationCompleted } from "../../../services/user";

const StartLearning = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { toast } = useToast();

  const startLearning = () => {
    registrationCompleted().then((res: any) => {
      if (StatusCode.SUCCESS === res.status)
        navigate(APPROUTES.personalizedUpdates);
      else
        toast({
          description: t("Validations.internalError"),
          variant: "error",
        });
    }).catch(() => {
      toast({
        description: t("Validations.internalError"),
        variant: "error",
      });
    })
    navigate(APPROUTES.personalizedUpdates);
  };

  return (
    <div className="grid md:grid-cols-1 h-dvh w-auto lg:w-[979px] mx-auto">
      <div className=" flex flex-col items-center justify-center dark:bg-black-900 p-5 py-32 mx:px-0 md:py-20 md:pb-36">

        <Button
          onClick={() => startLearning()}
          className="lg:w-[900px] h-auto py-2 text-base font-opensansSemiBold mb-4"
          dangerouslySetInnerHTML={{
            __html: t("Common.startLearning"),
          }}
        />

        <Card className="text-base bg-transparent border-0 xl:max-w-[910px] w-full h-full mid:p-11 mid:pt-0 mx-auto overflow-y-hidden">
          <CardContent className="px-0">
            <div className=" lg:h-[510px] lg:w-[900px] rounded-md mx-auto mb-16">
              <iframe src=" https://player.vimeo.com/video/1087028169?h=b44a33e3e8&autoplay=1&title=0&byline=0&portrait=0&playsinline=0"
                width="900" 
                height="510"
                allow="autoplay; fullscreen; picture-in-picture"
                className="w-full md:max-w-full lg:max-w-[910px] xl:max-w-[910px] aspect-[16/9] portrait:aspect-[16/9] object-cover rounded-[10px] border"
                allowFullScreen>
              </iframe>
              
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default StartLearning;
